import { Flex, Button, Box } from "@chakra-ui/react";

const Pagination = ({
  page,
  setPage,
  totalPages,
}: {
  page: number;
  setPage: (p: number) => void;
  totalPages: number;
}) => {
  const getPageNumbers = (): (number | string)[] => {
    const totalVisible = 7;
    const range: (number | string)[] = [];
  
    if (totalPages <= totalVisible) {
      // 전체 페이지 수가 7 이하면 전부 보여줌
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
  
    // 앞부분: 페이지가 1~4일 때
    if (page <= 4) {
      range.push(...[1, 2, 3, 4, 5, 6, 7], "...", totalPages);
      return range;
    }
  
    // 뒷부분: 페이지가 totalPages - 3 이상일 때
    if (page >= totalPages - 3) {
      range.push(1, "...", totalPages - 6, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      return range;
    }
  
    // 중간 부분
    range.push(
      1,
      "...",
      page - 2,
      page - 1,
      page,
      page + 1,
      page + 2,
      "...",
      totalPages
    );
    return range;
  };
  

  const pageNumbers = getPageNumbers();

  return (
    <Flex justifyContent="center" gap={2} py={2} wrap="wrap">
      <Button
        onClick={() => setPage(Math.max(page - 1, 1))}
        disabled={page === 1}
      >
        이전
      </Button>

      {pageNumbers.map((num, idx) =>
        typeof num === "string" ? (
          <Box
            key={`ellipsis-${idx}`}
            display="flex"
            alignItems="center"
            justifyContent="center"
            w="37.23px" // 버튼과 같은 너비
            h="35px" // 버튼과 같은 높이
            fontSize="sm"
            color="gray.500"
          >
            ...
          </Box>
        ) : (
          <Button
            key={num}
            variant={page === num ? "solid" : "outline"}
            colorScheme={page === num ? "teal" : "gray"}
            onClick={() => setPage(num)}
          >
            {num}
          </Button>
        )
      )}

      <Button
        onClick={() => setPage(Math.min(page + 1, totalPages))}
        disabled={page === totalPages}
      >
        다음
      </Button>
    </Flex>
  );
};

export default Pagination;
